<div class="wrapper">
  <div class="cuerpo">
    @if (loading) {
      <app-spinner></app-spinner>
    }

    @if (!loading) {
      <div>
        <div class="row documento">
          <h2> INFORMACIÓN DEL USUARIO </h2>
          <form name="entrar" class="formulario" autocomplete="off" [formGroup]="accountForm" (ngSubmit)="onSubmit()">
            <div class="flex-row">
              <mat-form-field class="example-full-width">
                <mat-label>Cif</mat-label>
                <input type="text" matInput formControlName="cif" required>
                @if (accountForm.controls.cif.hasError('required')) {
                  <mat-error>
                    Cif <strong>requerido</strong>
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Nombre usuario</mat-label>
                <input matInput formControlName="name" required>
                @if (accountForm.controls.name.hasError('required')) {
                  <mat-error>
                    Nombre de usuario <strong>requerido</strong>
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row">
              <mat-form-field>
                <mat-label>Teléfono</mat-label>
                <input matInput formControlName="phone">
                @if (accountForm.controls.phone.hasError('required')) {
                  <mat-error>
                    Móvil <strong>requerido</strong>
                  </mat-error>
                }
                @if (accountForm.controls.phone.hasError('minlength') || accountForm.controls.phone.hasError('maxlength')) {
                  <mat-error>
                    Móvil <strong>debe tener 9 caracteres</strong>
                  </mat-error>
                }
                @if (accountForm.controls.phone.hasError('pattern')) {
                  <mat-error>
                    Móvil debe iniciar con <strong>'+'</strong> y el <strong>indicativo</strong> del país, <strong>debe ser numérico</strong>
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="email">
                <mat-label>Correo</mat-label>
                <input matInput placeholder="Ex. pat@example.com" formControlName="email">
                @if (accountForm.controls.email.hasError('email') && !accountForm.controls.email.hasError('required')) {
                  <mat-error>
                    Por favor ingrese un correo válido
                  </mat-error>
                }
                @if (accountForm.controls.email.hasError('required')) {
                  <mat-error>
                    Correo <strong>requerido</strong>
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row">
              <mat-form-field>
                <mat-label>Nombre empresa</mat-label>
                <input matInput formControlName="businessName">
                @if (accountForm.controls.businessName.hasError('required')) {
                  <mat-error>
                    Nombre empresa <strong>requerido</strong>
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="email">
                <mat-label>Dirección</mat-label>
                <input matInput formControlName="direction">
                @if (accountForm.controls.direction.hasError('required')) {
                  <mat-error>
                    Dirección <strong>requerido</strong>
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row">
              <mat-form-field class="email">
                <mat-label>Correo remitente</mat-label>
                <input matInput placeholder="Ex. pat@example.com" formControlName="emailSender">
                @if (accountForm.controls.emailSender.hasError('email') && !accountForm.controls.emailSender.hasError('required')) {
                  <mat-error>
                    Por favor ingrese un correo válido
                  </mat-error>
                }
                @if (accountForm.controls.emailSender.hasError('required')) {
                  <mat-error>
                    Correo remitente <strong>requerido</strong>
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="email">
                <mat-label>Cuerpo de correo</mat-label>
                <input matInput placeholder="Ex. pat@example.com" formControlName="emailBody">
                @if (accountForm.controls.emailBody.hasError('email') && !accountForm.controls.emailBody.hasError('required')) {
                  <mat-error>
                    Por favor ingrese un correo válido
                  </mat-error>
                }
                @if (accountForm.controls.emailBody.hasError('required')) {
                  <mat-error>
                    Cuerpo de Correo <strong>requerido</strong>
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row">
              <mat-form-field>
                <mat-label>Url</mat-label>
                <input matInput formControlName="url">
                @if (accountForm.controls.url.hasError('required')) {
                  <mat-error>
                    Url <strong>requerido</strong>
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Url logo</mat-label>
                <input matInput formControlName="urlLogo">
                @if (accountForm.controls.urlLogo.hasError('required')) {
                  <mat-error>
                    Url logo <strong>requerido</strong>
                  </mat-error>
                }
                @if (accountForm.controls.urlLogo.hasError('pattern')) {
                  <mat-error>
                    Url logo <strong>debe ser una url valida</strong>
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="enviar2">
              <input type="submit" class="boton volver2" value="Guardar" [disabled]="!this.accountForm.dirty" (mouseover)="click()">
            </div>
          </form>
        </div>
      </div>
    }
  </div>
</div>


@if (viewForm) {
  <div class="ver-firmante contentPassword">
    <form name="entrar" class="formulario form-gen-doc changePassword" autocomplete="off" [formGroup]="passForm" (ngSubmit)="updatePassword()">
      <div class="row documento">
        <div class="flex-row filePassword">
          <mat-form-field class="example-full-width">
            <mat-label>Clave actual</mat-label>
            <input type="password" matInput formControlName="oldPassword" required>
            @if (passForm.controls.oldPassword.hasError('required')) {
              <mat-error>
                Clave actual <strong>requerido</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="flex-row filePassword">
          <mat-form-field class="example-full-width">
            <mat-label>Nueva clave</mat-label>
            <input type="password" matInput formControlName="newPassword" required>
            @if (passForm.controls.newPassword.hasError('required')) {
              <mat-error>
                Nueva clave <strong>requerido</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="flex-row filePassword">
          <mat-form-field class="example-full-width">
            <mat-label>Confirmar clave</mat-label>
            <input type="password" matInput formControlName="confirmPassword" required>
            @if (passForm.controls.confirmPassword.hasError('required')) {
              <mat-error>
                Confirmación de clave <strong>requerido</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="enviar2">
        <input type="button" (click)="cancel()" class="boton volver2" value="Cancelar">
        <input type="submit" class="boton volver2" value="Guardar">
      </div>
    </form>
  </div>
}
